// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { classic as _classic } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the classic chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 61
 * Chain Name: Ethereum Classic
 * Default Block Explorer: https://blockscout.com/etc/mainnet
 * Default RPC URL: https://etc.rivet.link
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { classic } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: classic,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const classic = createCommon({
	..._classic,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
